import * as actionTypes from 'constants/action-types';

export type SHOW_BACKDROP = 'SHOW_BACKDROP';
export const SHOW_BACKDROP: SHOW_BACKDROP = actionTypes.SHOW_BACKDROP;

export type HIDE_BACKDROP = 'HIDE_BACKDROP';
export const HIDE_BACKDROP: HIDE_BACKDROP = actionTypes.HIDE_BACKDROP;

export type SHOW_UPGRADABLE_MOCK_SERVICES = 'SHOW_UPGRADABLE_MOCK_SERVICES';
export const SHOW_UPGRADABLE_MOCK_SERVICES: SHOW_UPGRADABLE_MOCK_SERVICES = actionTypes.SHOW_UPGRADABLE_MOCK_SERVICES;

export type BackdropActionsActions = {
  type: HIDE_BACKDROP | SHOW_BACKDROP;
  text?: string;
};

export const showBackdrop = (text: string) => ({
  type: SHOW_BACKDROP,
  text: text,
});

export const hideBackdrop = () => ({
  type: HIDE_BACKDROP,
});

export type ShowUpgradableMocksAction = {
  type: SHOW_UPGRADABLE_MOCK_SERVICES;
  showUpgradableMocks: boolean;
};

export const ShowUpgradableMocks = () => ({
  type: SHOW_UPGRADABLE_MOCK_SERVICES,
});
